import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = (product: any) =>
    api.delete(url.DELETE_PRODUCT, {headers: {product}});

// add Products
export const addNewProduct = (product: any) =>
    api.create(url.ADD_NEW_PRODUCT, product);
// update Products
export const updateProduct = (product: any) =>
    api.update(url.UPDATE_PRODUCT, product);
